/**
 * La consulta de sesión, compartida por toda la aplicación.
 *
 * Sigue el patrón que ya usa `/api/configuracion`: una sola clave de TanStack
 * Query, y quien la necesite la vuelve a pedir. Con la misma clave, el
 * encabezado, el guardián de rutas y el formulario de registro ven exactamente
 * el mismo estado y una sola petición los abastece a los tres.
 *
 * `retry: false` a propósito. Los dos fallos posibles de `/api/perfil` son un
 * 503 —el esquema de autenticación no está aplicado— y una caída de red.
 * Ninguno se arregla reintentando en el mismo segundo, y reintentar solo
 * retrasa el mensaje que la persona necesita leer.
 */

import { useQuery } from '@tanstack/react-query'
import type { UseQueryResult } from '@tanstack/react-query'
import { obtenerPerfil } from '../api/perfil'
import type { Perfil } from '../api/perfil'

/** Clave única. Se exporta para poder invalidarla al entrar, salir o registrarse. */
export const CLAVE_PERFIL = ['perfil'] as const

export function usePerfil(): UseQueryResult<Perfil, Error> {
  return useQuery({
    queryKey: CLAVE_PERFIL,
    queryFn: obtenerPerfil,
    staleTime: 30_000,
    retry: false,
  })
}
